import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-3 items-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" log ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_external_link_icon = _resolveComponent("external-link-icon")!
  const _component_external_link = _resolveComponent("external-link")!
  const _component_PendingButton = _resolveComponent("PendingButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_external_link, {
      href: _ctx.href,
      class: "inline-flex items-center font-mono underline"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.hash) + " ", 1),
        _createVNode(_component_external_link_icon, { class: "w-3 h-3 ml-1.5" })
      ]),
      _: 1
    }, 8, ["href"]),
    _createVNode(_component_PendingButton, {
      class: "font-mono",
      onClick: _ctx.log,
      mode: _ctx.status ? 'normal' : 'pending'
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick", "mode"])
  ]))
}